import {
  ErrorHandler,
  NgModule,
  inject,
  provideAppInitializer
} from '@angular/core';
import { Router } from '@angular/router';
import * as SentryAngular from '@sentry/angular';
import { SentryService } from './sentry.service';

/**
 * Sentry Module.
 *
 * @class SentryModule
 * @exports
 */
@NgModule({
  imports: [SentryAngular.TraceModule],
  /**
   * @description Register Sentry Providers.
   * @see https://docs.sentry.io/platforms/javascript/guides/angular/#register-sentry-providers
   */
  providers: [
    {
      provide: ErrorHandler,
      useValue: SentryAngular.createErrorHandler()
    },
    {
      provide: SentryAngular.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(SentryAngular.TraceService);
    }),
    SentryService
  ]
})
export class SentryModule {}
